"use client";

import {tableService} from "@/service/table.service";
import {CircularProgress} from "@nextui-org/react";
import dynamic from "next/dynamic";
import {useCallback, useEffect, useState} from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import NoDataFound from "./commonTemplate/noDataFound";
import SideBarLoader from "./commonTemplate/sideBarLoader";
type NeoSideBarCardProps = {
  sideBar: sideBar;
  request: any;
  setSidebarReqData: any;
};
type sideBar = {
  type: string;
  api_url: string;
  menu?: string;
};
const Chart = dynamic(() => import("react-apexcharts"), {ssr: false});

export const TripStatus: React.FC<NeoSideBarCardProps> = ({
  sideBar: sidebar,
  request: request,
  setSidebarReqData: setSidebarReqData
}) => {
  const [sideBarData, setSidebarData] = useState<any>([]);
  const [currentTrackerId, setCurrentTrackerId] = useState<any>(0);
  const [metaDate, setMetaDate] = useState<any>([]);
  const [page, setPage] = useState<number>(1);
  const [hasMore, setHasMore] = useState<boolean>(true);
  const [isSidebarLoading, setSidebarIsLoading] = useState(false);

  const fetchData = useCallback(async () => {
    setSidebarIsLoading(true);
    const sideBarReq = {...request};
    //its used to remove the trackerId from the request
    //Reason if we pass the trackerId in the request then it will not show the data of all vehicles
    // so we need to remove the trackerId from the request
    if (request?.filters?.trackers && request?.filters?.trackers.length > 0) {
      sideBarReq.filters.trackers = [];
    }
    const results = await tableService.onGet(sidebar.api_url, 5, sideBarReq);
    setMetaDate(results.meta);
    if (results.rows.length > 0) {
      if (results.meta && results.meta.currentPage === 1) {
        setSidebarData(results.rows);
      } else {
        setSidebarData((prevData: any) => [...prevData, ...results.rows]);
      }

      if (results?.meta) {
        if (request.pageNumber === results.meta.totalPages) {
          setHasMore(false);
        } else {
          setHasMore(true);
        }
      } else {
        setHasMore(false);
      }
    } else {
      setHasMore(true);
      setMetaDate([]);
      setSidebarData([]);
    }
    setSidebarIsLoading(false);
  }, [sidebar.api_url, request]);

  useEffect(() => {
    //if the request.searchBy is present then we dont need to call the api
    //reason if we call the api with search by its will return data is matched the search by value
    if (sidebar && sidebar.api_url && request && !request.searchBy) {
      fetchData();
    }
  }, [sidebar, request, fetchData]);

  useEffect(() => {
    if (sideBarData && sideBarData.length > 0) {
      if (!currentTrackerId) {
        const firstTrackerId = sideBarData[0].trackerId;
        request.trackerId = firstTrackerId;
        request.filters.trackers = [firstTrackerId];
        setCurrentTrackerId(firstTrackerId);
        setSidebarReqData(request);
      } else {
        // its ignored api call when load more sidebar data
        if (currentTrackerId !== request.trackerId) {
          request.trackerId = currentTrackerId;
          request.filters.trackers = [currentTrackerId];
          setSidebarReqData(request);
        }
      }
    }
  }, [sideBarData]);
  const changeVehicle = (data: any) => {
    request.trackerId = data.trackerId;
    //request.threshold = data.threshold;
    request.filters.trackers = [data.trackerId];
    request.pageNumber = 1;
    setSidebarReqData(request);
    setCurrentTrackerId(data.trackerId);
  };

  const loadMore = () => {
    const nextPage = metaDate.currentPage + 1;
    //console.log(nextPage);
    request.pageNumber = nextPage;
    fetchData();
  };
  return (
    <>
      {isSidebarLoading && request.pageNumber && request.pageNumber == 1 ? (
        <SideBarLoader />
      ) : (
        <>
          {sideBarData && sideBarData.length == 0 ? (
            <NoDataFound />
          ) : (
            <div
              id="scrollableModal"
              className="h-[calc(100vh-100px)] overflow-y-auto"
            >
              <InfiniteScroll
                dataLength={sideBarData.length}
                next={loadMore}
                hasMore={hasMore}
                loader={
                  <div className="flex items-center justify-center p-4">
                    <CircularProgress aria-label="Loading..." color="warning" />
                  </div>
                }
                endMessage={
                  <p className="text-center text-gray-500">No more items</p>
                }
                scrollableTarget="scrollableModal"
                scrollThreshold={0.8} // Load when 80% scrolled
              >
                {sideBarData.map((data: any, index: number) => {
                  const yetToStart = Number(data.yetToStart || 0);
                  const inProgress = Number(data.inProgress || 0);
                  const completed = Number(data.completed || 0);
                  const notCompleted = Number(data.notCompleted || 0);

                  const total =
                    yetToStart + inProgress + completed + notCompleted;

                  // const chartSeries = total
                  //   ? [
                  //       (yetToStart / total) * 100,
                  //       (inProgress / total) * 100,
                  //       (completed / total) * 100,
                  //       (notCompleted / total) * 100
                  //     ]
                  //   : [0, 0, 0, 0];

                  // const chartOptions = {
                  //   chart: {width: "100px"},
                  //   dataLabels: {enabled: false},
                  //   legend: {show: false},
                  //   labels: [
                  //     "Yet to start",
                  //     "Inprogress",
                  //     "Completed",
                  //     "Not Completed"
                  //   ],
                  //   colors: ["#FACC15", "#3B82F6", "#22C55E", "#EF4444"]
                  // };
                  return (
                    <div
                      className="w-full max-w-md rounded-lg border bg-white p-4 shadow-md "
                      key={index}
                    >
                      <div className="flex flex-col items-center justify-between border-b-2 pb-2">
                        <h3 className="text-base font-medium text-gray-700 ">
                          {data.trackerName}
                        </h3>
                        <span className="text-xs text-gray-500 ">
                          {data.instituteName}
                        </span>
                      </div>
                      {/* <div className="flex items-center justify-between"> */}
                      {/* Donut Chart */}

                      {/* Legend & Data Count */}
                      <div className="flex items-center justify-between">
                        {/* Row 1 */}
                        <div className="flex flex-col ">
                          <div className="flex flex-col items-center">
                            <p className="text-sm font-medium text-gray-700 ">
                              Yet to Start
                            </p>
                            <div className="mb-1 h-1 w-10 rounded-full bg-yellow-500" />
                            <span className="text-base font-bold text-gray-800 ">
                              {yetToStart}
                            </span>
                          </div>
                          <div className="flex flex-col items-center">
                            <p className="text-sm font-medium text-gray-700 ">
                              Inprogress
                            </p>
                            <span className="mb-1 h-1 w-10 rounded-full bg-blue-500"></span>
                            <span className="text-base font-medium text-gray-800 ">
                              {inProgress}
                            </span>
                          </div>
                        </div>

                        {/* Row 2 */}
                        <div className="flex flex-col">
                          <div className="flex flex-col items-center">
                            <p className="text-sm font-medium text-gray-700 ">
                              Completed
                            </p>
                            <span className="mb-1 h-1 w-10 rounded-full bg-green-500"></span>
                            <span className="text-base font-medium text-gray-800 ">
                              {completed}
                            </span>
                          </div>
                          <div className="flex flex-col items-center">
                            <p className="text-sm font-medium text-gray-700 ">
                              Not Completed
                            </p>
                            <span className="mb-1 h-1 w-10 rounded-full bg-red-500"></span>
                            <span className="text-base font-medium text-gray-800">
                              {notCompleted}
                            </span>
                          </div>
                        </div>
                      </div>
                      {/* </div> */}
                      <button
                        className={`mt-2 w-full rounded-lg  py-1 text-sm font-medium transition ${
                          currentTrackerId === data.trackerId
                            ? "bg-green-700 text-white"
                            : "bg-neo-white text-neo-black hover:bg-green-700"
                        } flex items-center justify-center gap-2`}
                        onClick={() => changeVehicle(data)}
                      >
                        View Details
                        {data.count > 0 && (
                          <span
                            className={`flex h-5 w-5 items-center justify-center rounded-full text-xs font-bold text-white ${
                              data.count > 3 ? "bg-red-500" : "bg-yellow-500"
                            }`}
                          >
                            {data.count}
                          </span>
                        )}
                      </button>
                    </div>
                  );
                })}
              </InfiniteScroll>
            </div>
          )}
        </>
      )}
    </>
  );
};
